<template>
  <b-col md="12">
    <section class="accommodations">
      <div class="accommodations__header">
        <p class="mb-0">
          <strong class="semibold text--lg text-primary">Sistemazione degli ospiti per camera</strong><br>
          <span>Verifica che ogni camera sia adatta al numero e alla tipologia di viaggiatori altrimenti seleziona una camera diversa.</span>
        </p>
        <vb-button
          v-b-modal="'accommodations_modal'"
          :vb_options="{
            size: 'sm',
            variant: 'white'
          }"
        >
          <span>Cambia camera</span>
        </vb-button>
      </div>
      <card-recap :show_header="false" :show_price="false" :show_matching="true" :solution="solution" />
      <div
        v-if="occupancy_mismatches.length"
        class="accommodations__alert"
      >
        <p class="accommodations__alert-title">
          <vb-icon class="mr-1" :name="'exclamation'" :color="sass('danger')" :size="16" />
          <span>Una o più camere non hanno spazio per tutti gli ospiti.</span>
        </p>
        <ul class="accommodations__alert-list">
          <li v-for="item in occupancy_mismatches" :key="item.key">
            <strong v-if="item.index !== null" class="semibold">Gruppo {{ item.index + 1 }}: </strong>
            Serve spazio per {{ item.unallocated }}
          </li>
        </ul>
        <p class="accommodations__alert-desc">
          <span>Modifica la selezione delle camere per accogliere tutti gli ospiti.</span>
          <br/>
          <span v-b-modal="'accommodations_modal'">Puoi scegliere nuovamente le camere.</span>
        </p>
      </div>
      <vb-modal
        :vb_options="{
          id: 'accommodations_modal',
          body_class: 'accommodations__modal',
          title: 'Modifica la tua scelta',
          size: 'md',
          button_size: 'sm',
          ok_title: 'Procedi',
          ok_only: true,
          centered: true,
        }"
        @ok="$router.push('/detail')"
      >
        <p>Se clicchi su Procedi, la precedente scelta delle camere verrà annullata e potrai farla di nuovo.</p>
      </vb-modal>
    </section>
  </b-col>
</template>

<script>
import CardRecap from "@bookingv3/components/blocks/card-recap.vue"
import { format_occupancy_mismatch } from "@bookingv3/utilities"

export default {
  inheritAttrs: false,
  name: 'accommodations',

  components: {
    'card-recap': CardRecap,
  },

  props: {
    solution: Object,
  },

  data() {
    return {
    }
  },

  computed: {
    // Prodotti con occupancy_mismatch dalla preview: l'avviso mostra solo gli
    // ospiti non allocati (unallocated), es. "Serve spazio per 2 bambini (6 e 3 anni)".
    occupancy_mismatches() {
      const { accommodation } = this.solution
      const products = (accommodation && accommodation.products) || []

      return products
        .map(product => {
          const formatted = format_occupancy_mismatch(product.occupancy_mismatch)
          if (!formatted || !formatted.unallocated) return null

          const index = product.allocation ? product.allocation.index : null
          return {
            key: `${product.id}-${index}`,
            index,
            unallocated: formatted.unallocated,
          }
        })
        .filter(Boolean)
    },
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .accommodations {
    margin-top: $grid-gutter-width*2;

    &__header {
      margin-bottom: 20px;

      @include media-breakpoint-up(md) {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
      }

      .btn {
        margin-top: 20px;

        @include media-breakpoint-up(md) {
          margin-top: 0;
        }

        &-white {
          background-color: $white;
        }
      }
    }

    &__alert {
      color: $danger;
      margin-top: $grid-gutter-width/2;
      margin-left: 20px;

      &-title {
        display: flex;
        align-items: center;
        font-weight: $vb-font-weight-semibold;
        margin-bottom: 0;
      }

      &-list {
        list-style: none;
        padding-left: 0;
        margin: $grid-gutter-width/4 0;
        color: $vb-body-color;
      }

      &-desc {
        margin-top: $grid-gutter-width / 2;
        margin-bottom: 0;
        color: $vb-body-color;

        span:last-child, a {
          color: $info;
          text-decoration: underline;
        }
      }
    }
  }

</style>